import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { Regex } from 'src/app/Util/keys';

@Component({
  selector: 'app-combo-box',
  templateUrl: './combo-box.component.html',
  styleUrls: ['./combo-box.component.sass'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ComboBoxComponent),
      multi: true,
    },
  ],
})

export class ComboBoxComponent implements ControlValueAccessor {


  value: any;
  onChange = (value: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onValueChange(newValue: any): void {
    this.value = newValue;
    this.onChange(newValue); 
    this.onTouched(); 
    if(this.checkIfValuesInComboBox(newValue)){
      this.isComboBoxSelected.emit(true)
    }
    else{
      this.isComboBoxSelected.emit(false)
    }
  }
  @Input() options: string[] = [];
  @Input() defaultValue: string = '';

  @Input() readOnly: boolean = false;
  @Input() disabled: boolean = false;

  @Input() id = 'combo-box';
  @Input() placeholder = 'Please Type or Select an Option';

  @Input() invalid = false;
  @Input() errorMessage = 'Please Type or Select an Option';

  @Output() valueChange = new EventEmitter<string>();
  @Output() isComboBoxSelected = new EventEmitter<boolean>(false)

  searchTerm = '';
  filteredOptions: string[] = [];
  showOptions = false;
  hoveredIndex: number | null = null;
  selectedIndex: number | null = null;

  ngOnInit() {
    this.searchTerm = this.defaultValue || '';
    this.filteredOptions = [...this.options];
  }

  clearError() {
    if (this.invalid) {
      this.invalid = false;
    }
  }

  private checkIfValuesInComboBox(option:string){
    return this.options.find((x)=> x == option)
  }
  filterOptions() {
    
    if (this.searchTerm.trim()) {
      this.filteredOptions = this.options.filter((option) => option.toLowerCase().includes(this.searchTerm.toLowerCase()));

      if (this.filteredOptions.length > 0) {
        this.selectedIndex = 0; 
      }
    
    } else {
      this.filteredOptions = [...this.options];
    }

    this.showOptions = true;
  }

  onSearch() {

    this.filterOptions();  
  }

  onDropdownClick() {
    this.filterOptions();  
  }

  isActive(index: number): boolean {

    if (this.selectedIndex === null && this.hoveredIndex === null) {
      return index === 0 || index === this.hoveredIndex;
    }

    if (this.selectedIndex !== null) {
      return index === this.selectedIndex && this.hoveredIndex === null;
    }

    if (this.hoveredIndex !== null) {
      return index === this.hoveredIndex;
    }

    return false;
    
  }
  
  selectOption(option: string) {
    this.searchTerm = option;
    this.selectedIndex = this.filteredOptions.indexOf(option);
    this.valueChange.emit(option);
    this.showOptions = false; 
    this.isComboBoxSelected.emit(true)
  }

  onBlur() {
    this.showOptions = false;

    this.hoveredIndex = null;
    this.valueChange.emit(this.searchTerm);
  }

  onHover(index: number) {
    this.hoveredIndex = index;
  }

  onMouseLeave() {
    this.hoveredIndex = null;
  }
}
